export enum WEBSOCKET_MESSAGE_TYPES {
  AI = 'Ai',
  ERROR = 'Error',
  INTEREST = 'Interest',
  AUCTION = 'Auction',
  JOB = 'Job',
  JOB_MESSAGE = 'JobMessage',
  NOT_SUPPORTED = 'NotSupported',
  PONG = 'PingPong',
  SUPPORTED_ACTIONS = 'SupportedActions',
}
